export default __webpack_public_path__ + "static/media/kz.781fbde8.svg";